module.exports = __webpack_public_path__ + "img/map-b-1@2x.c01d3d92.png";